import tag from 'blacklist-tag';
import * as React from 'react';
import { Eye, EyeOff } from 'react-feather';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';
import { borderRadius, boxShadow, color, flex, height, space, width } from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { ThemeInterface } from '../../../theme/ThemeInterface';

interface Props extends StyledSystemProps {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string | number;
  height?: string | number;
  boxShadow?: string;
  max?: number;
  placeholder?: string;
  pattern?: string;
  showEyeIcon?: boolean;
  defaultChecked?: boolean;
  checked?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  readOnly?: boolean;
  value?: any;
  step?: string;
  wrapperDisplay?: string;
  wrapperTop?: string | number;
  wrapperWidth?: string | number;
  autoComplete?: string;
  mask?: any;
  // mask?: maskArray | ((value: string) => maskArray);
}

const CleanInput = tag('input', ['onTogglePassword', 'showEyeIcon', 'passwordVisible', 'borderRadius']);

const StyledInput = styled(CleanInput)`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${boxShadow};
  ${borderRadius};
  display: flex;
  position: relative;
  box-sizing: border-box;
  border: 1px solid rgba(50, 50, 93, 0.2);
  font-size: ${(props: ThemeInterface) => props.theme.fontSize[0]};
  &:disabled {
    opacity: 0.8;
    background-color: #cccccc;
  }
`;

const StyledMaskedInput = styled(MaskedInput)`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${boxShadow};
  ${borderRadius};
  display: flex;
  position: relative;
  box-sizing: border-box;
  border: 1px solid rgba(50, 50, 93, 0.2);
  font-size: ${(props: ThemeInterface) => props.theme.fontSize[0]};
  &:disabled {
    opacity: 0.8;
  }
`;

const InputWrap = styled.div`
  display: ${(props: Props) => props.wrapperDisplay || 'flex'};
  position: relative;
  align-items: center;
  top: ${(props: Props) => props.wrapperTop || 0};
  width: ${(props: Props) => props.wrapperWidth || '100%'};
`;

const StyledEye = styled(Eye)<any>`
  right: 10px;
  width: 20px;
  height: 20px;
  color: #404041;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
`;

const StyledEyeOff = styled(EyeOff)<any>`
  right: 10px;
  width: 20px;
  height: 20px;
  color: #404041;
  position: absolute;
  &:hover {
    cursor: pointer;
  }
`;

const PasswordIcon = (props: Props) => {
  return props.passwordVisible ? (
    <StyledEyeOff onClick={props.onTogglePassword} />
  ) : (
    <StyledEye onClick={props.onTogglePassword} />
  );
};

const Input: React.FC<Props> = (props: Props) => {
  const {
    wrapperDisplay,
    wrapperTop,
    wrapperWidth,
    onClick,
    mask,
    onTogglePassword,
    showEyeIcon,
    passwordVisible,
    borderRadius,
    ...rest
  } = props;
  const isCheckBox = rest.type === 'checkbox';

  return (
    <InputWrap wrapperDisplay={wrapperDisplay} wrapperTop={wrapperTop} wrapperWidth={wrapperWidth}>
      {mask !== undefined ? (
        <StyledMaskedInput mask={mask} guide={true} showMask={true} {...rest} />
      ) : props.name === 'cellNumber' || props.name === 'homeNumber' ? (
        <StyledMaskedInput mask={[/[0-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]} {...rest} />
      ) : (
        <StyledInput
          disabled={isCheckBox ? rest.readOnly : rest.disabled}
          onClick={onClick}
          {...rest}
          autoComplete={rest.autoComplete}
          borderRadius={borderRadius}
        />
      )}
      {showEyeIcon && PasswordIcon(props)}
    </InputWrap>
  );
};

export default Input;

Input.defaultProps = {
  width: '100%',
  height: '40px',
  bg: 'paleGrey',
  borderRadius: 4,
  passwordVisible: false,
  showEyeIcon: false,
};
